import React, {Component} from 'react'
import RaspaAlarmDashboardView from "./RaspaAlarmDashboardView";


const RaspaAlarmDashboard = ( props ) => {

 return (
            <RaspaAlarmDashboardView/>
        )

}



export default (RaspaAlarmDashboard);